/** Hash-route paths (docs/ui-spec.md §2). */

export const SettingsSection = {
  Time: 'time',
  Projects: 'projects',
  Checkin: 'checkin',
  ImportantDates: 'importantDates',
  Templates: 'templates',
  /** Data and sync: export, import, clearing, and the sync account (one section). */
  Data: 'data',
  /** The operation records (the device's operation log). */
  OpLog: 'oplog',
  Interface: 'interface',
  Diagnostics: 'diagnostics',
} as const;
export type SettingsSection = (typeof SettingsSection)[keyof typeof SettingsSection];

/** The former separate sync section: its address still opens the data and sync section. */
export const LEGACY_SYNC_SECTION = 'sync';

export const RoutePattern = {
  Root: '/',
  Day: '/day/:date',
  Week: '/week/:weekStart',
  Month: '/month/:month',
  Stats: '/stats',
  Settings: '/settings/:section?',
  Onboarding: '/onboarding',
  PrintBlank: '/print/blank/:weekStart',
  PrintWeek: '/print/week/:weekStart',
  /** Opened from the link of a verification mail; outside the welcome gate. */
  VerifyEmail: '/verify-email',
  LegalPrivacy: '/legal/privacy',
  LegalTerms: '/legal/terms',
} as const;

export const dayPath = (date: string): string => `/day/${date}`;
export const weekPath = (weekStart: string): string => `/week/${weekStart}`;
export const monthPath = (month: string): string => `/month/${month}`;
export const printBlankPath = (weekStart: string): string => `/print/blank/${weekStart}`;
export const printWeekPath = (weekStart: string): string => `/print/week/${weekStart}`;
export const STATS_PATH = '/stats';
export const ONBOARDING_PATH = '/onboarding';
export const settingsPath = (section: SettingsSection = SettingsSection.Time): string =>
  `/settings/${section}`;
export const VERIFY_EMAIL_PATH = '/verify-email';
export const legalPath = (doc: 'privacy' | 'terms'): string => `/legal/${doc}`;
